export default "__VITE_ASSET__e24f5554__"